import {Swiper, SwiperSlide} from "swiper/react"
import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import React, {Component} from "react";
import {
    EffectCoverflow,
    Pagination, Autoplay, Navigation
} from "swiper";
import "./ImageSliderStyles.css";
import './SwipperOverrideStyles.css'


class ImageSlider extends Component {
    constructor() {
        super();
        this.state = {
            actIndex: 2,
            titles: [
                "",
                "Направляйте обращения в Фонд",
                "Вся информация о получаемых услугах в Личном кабинете",
                "Заказывайте электронные справки",
                "Ознакомьтесь с порядком и способами получения пособия",
                "Звоните в сall-центр СФР",
                "Направляйте обращения в Фонд",
                "Вся информация о получаемых услугах в Личном кабинете",
                "Заказывайте электронные справки",
                "Ознакомтесь с порядком и способами получения пособия",
                "Звоните в сall центр СФР"
            ],
            visibleSlides: window.innerWidth > 768 ? 3 : 2,
            images: ['./slider/CN_1.svg', './slider/CN_1.png', './slider/CN_2.svg', './slider/CN_2.png', './slider/CN_3.svg', './slider/CN_3.png', './slider/CN_4.svg', './slider/CN_4.png', './slider/CN_5.svg', './slider/CN_5.png'],
            isRetina: window.devicePixelRatio >= 2
        }
        this.onChange = this.onChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    onChange(value) {
        value -= 5;
        if (value < 0) {
            value += 5;
        }
        if (value == 0) {
            value = 5;
        }
        this.setState({actIndex: value});
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        if (window.innerWidth > 768) {
            this.setState({visibleSlides: 3});
        } else {
            this.setState({visibleSlides: 2});
        }
    }

    render() {
        let title = this.state.titles[this.state.actIndex];
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        let screen4 = this.state.isRetina ? this.state.images[7] : this.state.images[6];
        let screen5 = this.state.isRetina ? this.state.images[9] : this.state.images[8];
        return (
            <div className={"slider-swiper-containr"}>
                <h2 className={"slider-swiper-title"}>{title}</h2>
                <div className={"slider-swiper-box"}>
                    <div className={"swiper-button-prev"}></div>
                    <Swiper
                        modules={[Pagination, EffectCoverflow, Autoplay, Navigation]}
                        effect={'coverflow'}
                        draggable={false}
                        allowTouchMove={false}
                        onSlideChangeTransitionEnd={(swiper) => this.onChange(swiper.activeIndex)}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                        }}
                        pagination={{clickable: true}}
                        centeredSlides={true}
                        slidesPerView={this.state.visibleSlides}
                        initialSlide={2}
                        loop={true}
                        loopAdditionalSlides={10}
                        coverflowEffect={{
                            rotate: 0,
                            modifier: 1,
                            depth: 350,
                            slideShadows: false
                        }}
                        className={"mySwiper"}
                    >
                        <SwiperSlide>
                            <div className={"slider-swiper-slide"}>
                                <img className={"myImage"} src={process.env.PUBLIC_URL + screen4}/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={"slider-swiper-slide"}>
                                <img className={"myImage"} src={process.env.PUBLIC_URL + screen5}/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={"slider-swiper-slide"}>
                                <img className={"myImage"} src={process.env.PUBLIC_URL + screen1}/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={"slider-swiper-slide"}>
                                <img className={"myImage"} src={process.env.PUBLIC_URL + screen2}/>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={"slider-swiper-slide"}>
                                <img className={"myImage"} src={process.env.PUBLIC_URL + screen3}/>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className={"swiper-button-next"}></div>
                </div>
            </div>
        );
    }
}

export default ImageSlider
